/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Svg from '../Svg/Svg';
import {hideAlert} from "../../../_actions/alert.actions";


class AlertBox extends Component {
    static get propTypes() {
        return {
            alerts: PropTypes.object,
            hideAlertBox: PropTypes.func
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            showAlert: false
        };
    }

    componentWillReceiveProps(nextProps){
        nextProps.alerts.show ?this.setState({showAlert: true}) : setTimeout(()=>{this.setState({showAlert: false});},500);
    }

    closeAlert = () => {
        this.props.hideAlertBox();
    };

    render() {
        const {alerts } = this.props;
        const showHideClass = alerts.show ? 'show' : 'hide';
        return(<div>
            {(!alerts.firstLoad && this.state.showAlert) && <div className={`alert-box ${showHideClass}`}>
                <div className="close-button" onClick={this.closeAlert}><span><Svg svgString='remove-sm-24'/></span></div>
                <div>
                    <p><strong className="pe-icon--btn">{alerts.message}</strong></p>
                </div>
            </div>}
        </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        alerts: state.alerts
    };
}

const mapDispatchToProps = dispatch => {
    return {
        hideAlertBox : () => {
            dispatch(hideAlert());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertBox);


// WEBPACK FOOTER //
// ./src/components/widgets/Alert/AlertBox.js